module.exports = __webpack_public_path__ + "img/stamp_toilet_on.314cad18.svg";